export interface SkillsTemplate {
  readonly id: number;
  readonly name: string;
}

export const decodeSkillsTemplate = (json: any): SkillsTemplate => ({
  id: json.id,
  name: json.name,
});
